import Client from "./Clients/AxiosClient";
const base = "/api/v1/user/products";
const detail = "/api/v1/user/product-details";

export default {
  get(type, search) {
    return Client.get(`${base}`, {
      params: {
        type,
        search,
      },
    });
  },
  getMyProducts() {
    return Client.get(`${base}/my-products`);
  },
  getDetail(id) {
    return Client.get(`${detail}/${id}`);
  },
  getDetailsDetail(id, detail_id) {
    return Client.get(`${detail}/${id}/${detail_id}`);
  },
};
